var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.207,
    height: 27.207,
    viewBox: "0 0 27.207 27.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "send",
    d: "M4.469,4.333a1.358,1.358,0,0,1,1.5-.19L30.453,16.386a1.359,1.359,0,0,1,0,2.435L5.966,31.065a1.361,1.361,0,0,1-1.9-1.646L7.558,18.964h7.326a1.36,1.36,0,0,0,0-2.721H7.558L4.068,5.789A1.365,1.365,0,0,1,4.469,4.333Z",
    transform: "translate(-4 -4)",
    fill: "#14a800",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.b7679218dd361913f042303bc785cf34.svg";
export { ForwardRef as ReactComponent };